// Conditional Vueform loader - only loads on localhost
export async function loadVueformConditionally(app: any) {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isStage = window.location.hostname.includes('appv5.stage-ovationcxm.app');
    const isPreprod = window.location.hostname.includes('appv5.preprod-ovationcxm.app');
    const isProd = window.location.hostname.includes('app.ovationcxm.com') || window.location.hostname.includes('appv5.ovationcxm.app');
    if (isLocalhost || isStage || isPreprod || isProd) {
        console.log('Loading Vueform and Builder on localhost, stage, preprod, or prod');
        try {
            // Dynamic import of Vueform packages only on localhost
            const [{ default: Vueform }, { default: vueformConfig }, { default: Builder }, { default: builderConfig }] =
                await Promise.all([
                    import('@vueform/vueform'),
                    import('../vueform-with-builder.config'),
                    import('@vueform/builder'),
                    import('../builder.config'),
                ]);

            console.log('Loading Vueform and Builder on localhost');
            app.use(Vueform, vueformConfig);
            app.use(Builder, builderConfig);
        } catch (error) {
            console.warn('Failed to load Vueform packages:', error);
        }
    } else {
        try {
            // Only load basic Vueform without Builder on non-localhost
            const [{ default: Vueform }, { default: vueformConfig }] = await Promise.all([
                import('@vueform/vueform'),
                import('../vueform-no-builder.config'),
            ]);

            console.log('Loading Vueform without Builder on stage environment');
            app.use(Vueform, vueformConfig);
        } catch (error) {
            console.warn('Failed to load Vueform:', error);
        }
    }
}
